import Entity, { fetchArray } from "entity"
import { ValidatorHelper } from "functions"

export default class Grupo extends Entity {
    static get collectionUID() {
        return "Grupo";
    }
    async initialize() {
        this.data.status = "ATIVO";
    }
    static async onQuery(collection) {
        return collection/*.where("status", "==", "ATIVO")*/.orderBy("nome")
    }

    static async validFieldErrors(values) {
        // console.log('values', values)
        let v = new ValidatorHelper();

        v.addRequired("nome", "NOME DO GRUPO")

        let errorsMessage = v.valid(values);
        // console.log("errorsMessage", errorsMessage)
        if (errorsMessage.length) {
            return errorsMessage
        }

        let result = await fetchArray(this.getAll())

        let temIgual

        // verificando duplicidade em alteração de grupo
        if (values.uid) {
            temIgual = result.filter(g => {
                if (g.nome.toUpperCase() === values.nome.toUpperCase()
                    && g.uid !== values.uid
                ) {
                    return true
                } else {
                    return false
                }
            })
        }
        
        // verificando duplicidade em criação de grupo
        else {
            temIgual = result.filter(g => g.nome.toUpperCase() === values.nome.toUpperCase())
        }

        if (temIgual.length) {
            return ["Grupo já existe"]
        }

        return null
    }

    static get labelField() {
        return "nome";
    }

    static get searchColumns() {
        return [
            // { field: "sequencialIndex", headerName: "Código", flex: 0.8, filter: true },
            { field: "status", headerName: "STATUS", flex: 0.125, filter: true },
            { field: "nome", headerName: "NOME DO GRUPO", flex: 2, filter: true },
        ];
    }
}